<template>
  <hm-content title="">
    <div class="mt20 flex item-center">
      <div class="wd">
         输入管家婆订单号:
      </div>
     
      <el-input
        style="width:200px"
        clearable
        v-model.trim="receiptSn"
        placeholder="请输入管家婆订单号"
        size="small"
        class="mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="confirm">确 认</el-button>
    </div>
    <div class="mt20 flex item-center">
      <div class="wd">
     输入华创订单号:

      </div>
      <el-input
        style="width:200px"
        clearable
        v-model.trim="receiptSnHc"
        placeholder="请输入华创订单号"
        size="small"
        class="mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="confirmHc('hc')">确 认</el-button>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      receiptSn: "",
      receiptSnHc: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    async confirm() {
      if (this.receiptSn !== "") {
        const { code } = await this.$store.dispatch("orderPushSupply", {
          receiptSn: this.receiptSn
        });
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.receiptSn = "";
        }
      }
    },
    async confirmHc(type) {
      if (this.receiptSnHc !== "") {
        const { code } = await this.$store.dispatch("orderPushSupply", {
          receiptSn: this.receiptSnHc,
          type
        });
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.receiptSnHc = "";
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wd {
  width: 130px;
  text-align: right;
}
</style>
